export const ERROR_MESSAGE = "ERROR_INTERNET_DISCONNECTED";
export const ERROR_TEXT = "Internet connection is not available";